import React from 'react'
import Button from './Button'

const ButtonLeft = (props) => {
  return (
    <Button
      icon="ChevronLeft"
      {...props}
    />
  )
}

export default ButtonLeft
